import { render, staticRenderFns } from "./MerchantsShow.vue?vue&type=template&id=66a85732&"
import script from "./MerchantsShow.vue?vue&type=script&lang=js&"
export * from "./MerchantsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports